export const cookieContent = {
  text: 'เว็บไซต์นี้มีการใช้งานคุกกี้เพื่อปรับปรุงการใช้บริการออนไลน์ของท่าน โดยเราจะใช้คุกกี้เมื่อท่านเข้ามาหน้าเว็บไซต์ สามารถอ่านรายละเอียดเพิ่มเติมได้ที่',
  link: 'นโยบายการใช้คุกกี้',
  btnAccept: 'เข้าใจแล้ว',
};
